export default [
  {
    id: 'small',
    name: 'Small (< 200 teams)',
  },
  {
    id: 'medium',
    name: 'Medium (< 500 teams)',
  },
  {
    id: 'large',
    name: 'Large (> 500 teams)',
  },
];
